import axios from "axios";

//state
export var promotionState = {
  promotion: {},
  promotions: [],
  status_promotions: ""
};

//getters
export var promotionGetters = {
  //funciones para optener informacion del state
  getPromotion: state => state.promotion,
  getPromotions: state => state.promotions
};

//actions
export var promotionActions = {
  async getPromotions({ commit }) {
    commit("promotion_request");
    console.log("here for page");
    await this._vm.$http
      .get("/apache/rest_api/apache.promotion", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'name', 'objective',('partner_id', ['id', 'name']),('country_id', ['id', 'name']),'redirect_url', 'tracking_url','direct_url', 'payout', ('strategic_id', ['id', 'name'] ), ['lines_ids', ['id', 'name']], ['city_ids', ['id', 'name']], ['state_ids', ['id', 'name']],['targeting_ids', ['id', 'name']]  ]"
        }
      })
      .then(res => {
        const promotions = res.data;
        commit("promotions_success", promotions);
        return promotions;
      })
      .catch(err => {
        commit("promotion_error");
        return err;
      });
  },
  async newPromotion({ commit, state }, promotion) {
    commit("promotion_request");
    var {
      name,
      objective,
      redirect_url,
      tracking_url,
      direct_url,
      payout,
      strategic_id,
      lines_ids,
      city_ids,
      partner_id,
      partnerSelected,
      country_id,
      selectedCountry,
      strategyActionsSelected,
      linesSelected,
      state_ids,
      targeting_ids,
      statesSelected,
      targetsSelected
    } = promotion;
    var formData = new FormData();
    var newPropuesta = `
    {
      'name':'${name}',
      'objective': '${objective}',
      'redirect_url':'${redirect_url}',
      'direct_url':'${direct_url}',
      'tracking_url':'${tracking_url}',
      'payout':'${payout}',
      'partner_id':'${partner_id}',
      'strategic_id': '${strategic_id}',
      'state_ids': [${state_ids}],
      'targeting_ids': [${targeting_ids}],
      'lines_ids': [${lines_ids}],
      'city_ids':'[${city_ids}]',
      'country_id':'${country_id}',
      'relational_fields': [ ('targeting_ids', 'apache.adset.targeting'), ('state_ids', 'res.country.state'),('strategic_id', 'apache.strategic_action'), ('lines_ids', 'apache.content_line'),('city_ids', 'res.city')]
    }`;
    formData.append("data", newPropuesta);
    await this._vm.$http
      .post("/apache/rest_api/apache.promotion", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          promotion = {
            ...promotion,
            id: res.data.id,
            partner_id: partnerSelected,
            country_id: selectedCountry,
            objective: objective,
            strategic_id:strategyActionsSelected,
            lines_ids:linesSelected,
            targeting_ids:targetsSelected,
            state_ids:statesSelected
          };
          var promotions = state.promotions;
          promotions.push(promotion);
          commit("promotion_success", promotions);
          return promotions;
        } else {
          commit("promotion_error");
        }
      })
      .catch(err => {
        commit("promotion_error");
        return err;
      });
  },
  async editPromotion({ commit, state }, promotion) {
    commit("promotion_request");
    var {
      id,
      name,
      objective,
      redirect_url,
      tracking_url,
      direct_url,
      linesSelected,
      strategyActionsSelected,
      payout,
      strategic_id,
      lines_ids,
      city_ids,
      partner_id,
      partnerSelected,
      country_id,
      selectedCountry,
      state_ids,
      targeting_ids,
      statesSelected,
      targetsSelected
    } = promotion;
    var formData = new FormData();
    var newPropuesta = `
    {
      'name':'${name}',
      'objective': '${objective}',
      'redirect_url':'${redirect_url}',
      'tracking_url':'${tracking_url}',
      'direct_url':'${direct_url}',
      'payout':'${payout}',
      'partner_id':'${partner_id}',
      'strategic_id': '${strategic_id}',
      'state_ids': [${state_ids}],
      'targeting_ids': [${targeting_ids}],
      'lines_ids': [${lines_ids}],
      'city_ids':'[${city_ids}]',
      'country_id':'${country_id}',
      'relational_fields': [ ('targeting_ids', 'apache.adset.targeting'), ('state_ids', 'res.country.state'),('strategic_id', 'apache.strategic_action'), ('lines_ids', 'apache.content_line'),('city_ids', 'res.city')]
    }`;
    formData.append("data", newPropuesta);
    await this._vm.$http
      .put("/apache/rest_api/apache.promotion", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          promotion = {
            ...promotion,
            id: id,
            partner_id: partnerSelected,
            country_id: selectedCountry,
            objective: objective,
            strategic_id:strategyActionsSelected,
            lines_ids:linesSelected,
            targeting_ids:targetsSelected,
            state_ids:statesSelected
          };
          var index;
          var promotions = state.promotions;
          for (var i = 0; i < promotions.length; i++) {
            if (promotions[i].id == id) {
              index = i;
              promotions[i] = promotion;
              break;
            }
          }
          promotions.splice(index, 1);
          promotions.splice(index, 0, promotion);
          promotions.push(promotion);
          commit("promotion_success", promotions);
          return promotions;
        } else {
          commit("promotion_error");
        }
      })
      .catch(err => {
        commit("promotion_error");
        return err;
      });
  },
  async deletePromotion({ commit, state }, id) {
    commit("promotion_request");
    try {
      await this._vm.$http
        .delete(`/apache/rest_api/apache.promotion/${id}`, {
          headers: {
            "X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          /*if (res.status == 210) {
            var index;
            var strategyActions = state.strategyActions;
            for (var i = 0; i < strategyActions.length; i++) {
              if (strategyActions[i].id == id) {
                index = i;
                break;
              }
            }
            strategyActions.splice(index, 1);
            commit("strategyAction_success", strategyActions);

            return strategyActions;
          } else {
            commit("strategyAction_error");
          }
        */
        })
        .catch(err => {
          commit("strategyAction_error");
          return err;
        });
    } catch (error) {
      console.log(error);
    }
  },
  async deletePromotionUtility({ commit, state }, id) {
    commit("promotion_request");
    var index;
    var promotions = state.promotions;
    for (var i = 0; i < promotions.length; i++) {
      if (promotions[i].id == id) {
        index = i;
        break;
      }
    }
    promotions.splice(index, 1);
    commit("strategyAction_success", promotions);

    return promotions;
  }
};

//mutations

export var promotionMutations = {
  promotion_request(state) {
    state.status_promotions = "loading";
  },
  promotion_success(state, payload) {
    state.status_promotions = "success";
    state.promotion = payload;
  },
  promotions_success(state, payload) {
    state.status_promotions = "success";
    state.promotions = payload;
  },
  promition_error(state) {
    state.status_promotions = "error";
  }
};
